/*
 * React-based URL linkification for rendered components.
 *
 * For frontend use only — depends on React.
 */
import { createElement, Fragment, type ReactNode } from 'react';

const BARE_URL_REGEX = /(https?:\/\/[^\s<>)"',\]]+)/g;
const BARE_URL_TEST = /https?:\/\/[^\s<>)"',\]]+/;

export const linkifyChildren = (children: ReactNode, linkClassName?: string): ReactNode => {
  if (typeof children === 'string' && BARE_URL_TEST.test(children)) {
    const parts = children.split(BARE_URL_REGEX);
    return parts.map((part, i) =>
      i % 2 === 1
        ? createElement(
            'a',
            { key: i, href: part, target: '_blank', rel: 'noopener noreferrer', ...(linkClassName ? { className: linkClassName } : {}) },
            part,
          )
        : createElement(Fragment, { key: i }, part),
    );
  }
  if (Array.isArray(children)) {
    return children.map((child, i) =>
      typeof child === 'string' && BARE_URL_TEST.test(child)
            ? createElement(Fragment, { key: i }, linkifyChildren(child, linkClassName))
        : child,
    );
  }
  return children;
};
